import { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import { AppRulesContext } from "../App";
import GuardedRoute from "../components/GuardedRoute";
import PageNotFound from "../pages/PageNotFound";
import TaxExpertAdd from "../pages/tax-experts/TaxExpertAdd";
import TaxExpertDetails from "../pages/tax-experts/TaxExpertDetails";
import TaxExperts from "../pages/tax-experts/TaxExperts";

const TaxExpertNavigator = () => {
  const { rulesSvc } = useContext(AppRulesContext);

  return (
    <Routes>
      <Route index element={<GuardedRoute rules={rulesSvc.usersList} element={<TaxExperts />} />} />
      <Route
        path=":uUId"
        element={<GuardedRoute rules={rulesSvc.updateUser} element={<TaxExpertDetails />} />}
      />
      <Route
        path="add"
        element={<GuardedRoute rules={rulesSvc.createUser} element={<TaxExpertAdd />} />}
      />
      {/* URL Not Found */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default TaxExpertNavigator;
